import type { Product } from "../types/store";

export function extractUniqueCategories(products: Product[]): string[] {
  const categorySet = new Set<string>();

  products.forEach((product) => {
    // Add category from the main product
    if (product.category) {
      categorySet.add(product.category);
    }

    // Add category from StoreCategory relation if present
    if (product.StoreCategory?.category) {
      categorySet.add(product.StoreCategory.category);
    }
  });

  return Array.from(categorySet);
}